import React from "react";
import {
  FormControl,
  FormLabel,
  TextField,
  Grid,
  GridProps,
} from "@mui/material";
import { FORM_STYLES, FORM_CLASSES, S_GRID_PROPS } from "../../../constants";

export interface DisabledLabeledTextFieldProps {
  id: string;
  label: string;
  value?: string | number | null;
  gridProps?: GridProps;
  multiline?: boolean;
  rows?: number;
}

const DisabledLabeledTextField: React.FC<DisabledLabeledTextFieldProps> = ({
  id,
  label,
  value = "",
  gridProps = S_GRID_PROPS,
  multiline = false,
  rows = 1,
}) => {
  return (
    <Grid item {...gridProps}>
      <FormControl
        fullWidth
        size={FORM_STYLES.FIELD_SIZE}
        className={FORM_CLASSES.FORM_CONTROL}
      >
        <FormLabel
          id={`${id}Label`}
          htmlFor={`${id}-input`}
          className={FORM_CLASSES.LABEL_BASE}
          style={FORM_STYLES.LABEL}
        >
          {label}
        </FormLabel>
        <TextField
          autoComplete="off"
          fullWidth
          id={id}
          name={id}
          value={value ?? ""}
          disabled
          multiline={multiline}
          data-testid={id}
          rows={rows}
          title={(value?.toString()?.length ?? 0) > 30 ? value?.toString() : undefined}
          inputProps={{
            "data-testid": `${id}-input`,
            id: `${id}-input`,
            style: FORM_STYLES.INPUT,
          }}
          variant="outlined"
          size="small"
        />
      </FormControl>
    </Grid>
  );
};

export default DisabledLabeledTextField;
